<template lang="pug">
  include ../../../../pug/mixins/bem
  +b.pagination-wrapper
    +b.default-btn.ajax-pagination.A(href='', 
                                    ref='pagination'
                                    v-if='!end'
                                    @click.prevent='getPaginate()') {{ _("Показать еще") }}
</template>
<script>
export default {
  name: "LoadMore",
  props: {
    page: {},
    current: {
      type: Number
    }
  },
  created() {
    this.currentMutable = this.current
  },
  data() {
    return {
      initial: 2,
      trigger: 300,
      end: false,
      currentMutable: 0
    }
  },
  watch: {
    page: {
      handler(nval) {
        if (nval.page <= this.currentMutable) {
          this.end = true
        }
      }, 
      deep: true
    }
  },
  mounted() {
    // window.addEventListener("scroll", () => {
    //   if (
    //     window.innerHeight + window.scrollY >=
    //     document.body.offsetHeight - this.trigger
    //   ) {
    //     if (this.current < this.length) {
    //       this.$emit("paginate", this.initial++)
    //     } else {
    //       this.end = true
    //     }
    //   }
    // })
  },
  methods: {
    getPaginate() {
      this.currentMutable++
      this.$emit("paginate", this.initial++)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/js/shared/components/articles/LoadMore.vue